module.exports = __webpack_public_path__ + "img/类别权限.aeeb4d61.svg";